export const useSlugify = () => useNuxtApp().$slugify;
